import React from 'react'

const Home = () => {
  return (
    <div className="home d-flex-column justify-content-center align-items-center">
   

  <div className='home-body container text-center text-light font-monospace'>
    <h1>Willkommen <br /> Interview Fragen App</h1>
  </div>
    </div>
  )
}

export default Home